const DatumToString = (datum) => {
    // console.log(`Datum: '${datum}'`)
    if ((datum === 'NaN.NaN.NaN') || (datum === null) || datum === '')
        return '';
    const date = new Date(`${datum}`);
    const theGermanDate = date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
    // console.log(`Datum als deutsches Date: ${theGermanDate}`)
    return theGermanDate;
}

const getDateTime = (datum) => {
    var now     = new Date(`${datum}`); 
    var year    = now.getFullYear();
    var month   = now.getMonth()+1; 
    var day     = now.getDate();
    var hour    = now.getHours();
    var minute  = now.getMinutes();
    var second  = now.getSeconds(); 
    if(month.toString().length === 1) {
         month = '0'+month;
    }
    if(day.toString().length === 1) {
         day = '0'+day;
    }   
    if(hour.toString().length === 1) {
         hour = '0'+hour;
    }
    if(minute.toString().length === 1) {
         minute = '0'+minute;
    }
    if(second.toString().length === 1) {
         second = '0'+second;
    }   
    var dateTime = day+'.'+month+'.'+year+', '+hour+':'+minute+':'+second+'.000';   
     return dateTime;
}


export {
    DatumToString,
    getDateTime,
};